import script from "./VirtualLiveWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./VirtualLiveWidget.vue?vue&type=script&setup=true&lang=js"

import "./VirtualLiveWidget.vue?vue&type=style&index=0&id=390ac694&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-390ac694"]])

export default __exports__